import {
  type ReactElement, useEffect,
} from 'react';

import useVerificationSms from './hooks/useVerificationSms';
import VerificationSmsView from './VerificationSmsView';

function VerificationSms(): ReactElement {
  const {
    control,
    onVerificationSmsSubmit,
    onResendCode,
    time,
    isTimeUp,
    phone,
    isButtonDisabled,
    isLoading,
  } = useVerificationSms({});

  useEffect(() => {
    onResendCode();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <VerificationSmsView
      control={control}
      onVerificationSmsSubmit={onVerificationSmsSubmit}
      onResendCode={onResendCode}
      time={time}
      isTimeUp={isTimeUp}
      phone={phone}
      isButtonDisabled={isButtonDisabled}
      isLoading={isLoading}
    />
  );
}

export default VerificationSms;
